import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, Validators, FormControl, ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getStepDetails } from 'visa-store';
import * as i3 from 'app-services-library';
import * as i4 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class CustomTextFieldService {
    constructor() { }
}
CustomTextFieldService.ɵfac = function CustomTextFieldService_Factory(t) { return new (t || CustomTextFieldService)(); };
CustomTextFieldService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomTextFieldService, factory: CustomTextFieldService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomTextFieldService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomTextFieldComponent_em_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomTextFieldComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1, " Required");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function CustomTextFieldComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Minimum length is ", ctx_r2.inputParams == null ? null : ctx_r2.inputParams.minLength, "");
} }
function CustomTextFieldComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Maximum length is ", ctx_r3.inputParams.maxLength, "");
} }
function CustomTextFieldComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2, "Only numbers are allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function CustomTextFieldComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2, "Special Characters are not allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function CustomTextFieldComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.sublabel);
} }
function CustomTextFieldComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "input", 14);
    i0.ɵɵlistener("click", function CustomTextFieldComponent_div_14_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.checkboxToggle($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r7.inputParams == null ? null : ctx_r7.inputParams.checkboxLabel);
} }
const _c0 = function (a0) { return { "width": a0 }; };
class CustomTextFieldComponent {
    constructor(parentFor, fb, changeDetectorRef, store, appServicesLibraryService) {
        this.parentFor = parentFor;
        this.fb = fb;
        this.changeDetectorRef = changeDetectorRef;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.group = new FormGroup({});
        this.observableSubscription$ = new Subject();
        this.userType = '';
    }
    ngOnInit() {
        this.userType = sessionStorage.getItem('userTypeRole');
        let textFieldVal_data = this.inputParams.value && this.inputParams.value.textFieldVal ? this.inputParams.value.textFieldVal : '';
        let checkbox_val_data = this.inputParams.value && this.inputParams.value.checkbox_val ? this.inputParams.value.checkbox_val : false;
        const textFieldValidators = this.inputParams.mandatory ? [Validators.required] : [];
        if (this.inputParams.minLength) {
            textFieldValidators.push(Validators.minLength(this.inputParams.minLength));
        }
        if (this.inputParams.maxLength) {
            textFieldValidators.push(Validators.maxLength(this.inputParams.maxLength));
        }
        if (this.inputParams.numbersOnly) {
            textFieldValidators.push((control) => {
                const inputVal = control.value;
                return inputVal === '' || /^\d+$/.test(inputVal) ? null : { numbersOnly: true };
            });
        }
        if (this.inputParams.noSpecialCharacters) {
            textFieldValidators.push((control) => {
                const inputVal = control.value;
                return inputVal === '' || /^[a-zA-Z0-9\s@.]*$/.test(inputVal) ? null : { noSpecialCharacters: true };
            });
        }
        if (this.inputParams.stepName && this.inputParams.stepName == 'Send Receipt') {
            textFieldVal_data = '';
        }
        this.group.addControl(this.inputParams.name, new FormGroup({
            textFieldVal: new FormControl(textFieldVal_data, textFieldValidators),
            checkbox_val: new FormControl(checkbox_val_data)
        }));
        if (this.inputData) {
            this.toggleInputFields();
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                // console.log(this.inputData);
                this.toggleInputFields();
            });
        }
    }
    toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
    }
    checkboxToggle(event) {
        if (event.target.checked) {
            this.inputParams.value.checkbox_val = true;
            this.group.controls[this.inputParams.name].patchValue({
                textFieldVal: '',
                checkbox_val: true
            });
        }
        else {
            this.inputParams.value.checkbox_val = false;
            this.group.controls[this.inputParams.name].patchValue({
                textFieldVal: '',
                checkbox_val: false
            });
        }
    }
    isInputNumeric() {
        var _a, _b;
        const inputVal = (_b = (_a = this.group.get(this.inputParams.name)) === null || _a === void 0 ? void 0 : _a.get('textFieldVal')) === null || _b === void 0 ? void 0 : _b.value;
        return /^\d+$/.test(inputVal);
    }
    ngOnChanges(e) {
        // console.log(e);
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
CustomTextFieldComponent.ɵfac = function CustomTextFieldComponent_Factory(t) { return new (t || CustomTextFieldComponent)(i0.ɵɵdirectiveInject(i1.FormGroupDirective), i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService)); };
CustomTextFieldComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomTextFieldComponent, selectors: [["custom-text-field"]], inputs: { validation: "validation", readonly: "readonly", sublabel: "sublabel", minLength: "minLength", maxLength: "maxLength", placeHolders: "placeHolders", value: "value", formControlName: "formControlName", inputParams: "inputParams", inputData: "inputData", group: "group" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ]), i0.ɵɵNgOnChangesFeature], decls: 15, vars: 18, consts: [[1, "text-field", 3, "formGroup"], [3, "formGroupName"], [1, "label-cls", "d-block"], [1, "common-bene-class-for-translation"], ["class", "error", 4, "ngIf"], ["type", "text", "aria-label", "inputParams?.label", "formControlName", "textFieldVal", 1, "form-control", 2, "width", "100%", 3, "ngClass", "maxLength", "readonly"], ["class", "error common-bene-class-for-translation", 4, "ngIf"], [4, "ngIf"], ["class", "sublabel", 4, "ngIf"], ["class", "checkbox", 4, "ngIf"], [1, "error"], [1, "error", "common-bene-class-for-translation"], [1, "sublabel"], [1, "checkbox"], ["type", "checkbox", "formControlName", "checkbox_val", 3, "click"], [2, "float", "left", "font-size", "14px", "padding-left", "8px"]], template: function CustomTextFieldComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "label", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, CustomTextFieldComponent_em_5_Template, 2, 0, "em", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "input", 5);
        i0.ɵɵelementStart(7, "div");
        i0.ɵɵtemplate(8, CustomTextFieldComponent_span_8_Template, 3, 0, "span", 6);
        i0.ɵɵtemplate(9, CustomTextFieldComponent_ng_container_9_Template, 4, 1, "ng-container", 7);
        i0.ɵɵtemplate(10, CustomTextFieldComponent_ng_container_10_Template, 4, 1, "ng-container", 7);
        i0.ɵɵtemplate(11, CustomTextFieldComponent_ng_container_11_Template, 3, 0, "ng-container", 7);
        i0.ɵɵtemplate(12, CustomTextFieldComponent_ng_container_12_Template, 3, 0, "ng-container", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, CustomTextFieldComponent_div_13_Template, 3, 1, "div", 8);
        i0.ɵɵtemplate(14, CustomTextFieldComponent_div_14_Template, 5, 1, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_8_0 = null;
        let tmp_9_0 = null;
        let tmp_9_1 = null;
        let tmp_10_0 = null;
        let tmp_10_1 = null;
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(16, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", (ctx.inputParams == null ? null : ctx.inputParams.value == null ? null : ctx.inputParams.value.checkbox_val) ? "disabledTextArea" : "")("maxLength", (ctx.inputParams == null ? null : ctx.inputParams.maxLength) ? ctx.inputParams == null ? null : ctx.inputParams.maxLength : "150")("readonly", (ctx.inputParams == null ? null : ctx.inputParams.isReadonly) ? true : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ((tmp_8_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_8_0.touched) && ctx.group.get(ctx.inputParams.name).get("textFieldVal").value === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.minLength) !== null && (ctx.inputParams == null ? null : ctx.inputParams.minLength) !== "" && (ctx.group == null ? null : (tmp_9_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : (tmp_9_1 = tmp_9_0.get("textFieldVal")) == null ? null : tmp_9_1.value == null ? null : tmp_9_1.value.length) < (ctx.inputParams == null ? null : ctx.inputParams.minLength) && (ctx.group == null ? null : (tmp_9_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_9_0.touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.maxLength) && (ctx.inputParams == null ? null : ctx.inputParams.maxLength) !== "" && (ctx.group == null ? null : (tmp_10_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : (tmp_10_1 = tmp_10_0.get("textFieldVal")) == null ? null : tmp_10_1.value == null ? null : tmp_10_1.value.length) > (ctx.inputParams == null ? null : ctx.inputParams.maxLength));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.numbersOnly) && !ctx.isInputNumeric() && ctx.group.get(ctx.inputParams.name).get("textFieldVal").value !== "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.noSpecialCharacters) && ctx.group.get(ctx.inputParams.name).get("textFieldVal").value !== "" && (ctx.group.get(ctx.inputParams.name).get("textFieldVal").errors == null ? null : ctx.group.get(ctx.inputParams.name).get("textFieldVal").errors.noSpecialCharacters));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sublabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.isChecked);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormGroupName, i4.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.FormControlName, i4.NgClass, i1.CheckboxControlValueAccessor], styles: [".text-field[_ngcontent-%COMP%]{width:100%;margin-bottom:10px}.text-field[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:12px;color:#3b3b3b;margin-bottom:4px}.text-field[_ngcontent-%COMP%]   .overflowHidden[_ngcontent-%COMP%]{overflow:hidden;padding-bottom:5px;height:auto}.text-field[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.text-field[_ngcontent-%COMP%]   .sublabel[_ngcontent-%COMP%]{font-size:12px}.text-field[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]{text-align:left;margin:8px 0 0;padding:0}.text-field[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{width:20px;height:20px;float:left}.text-field[_ngcontent-%COMP%]   .disabledTextArea[_ngcontent-%COMP%]{pointer-events:none;background:#cecece}.form-control[_ngcontent-%COMP%]{height:40px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomTextFieldComponent, [{
        type: Component,
        args: [{
                selector: 'custom-text-field',
                templateUrl: 'custom-text-field.component.html',
                styleUrls: ['custom-text-field.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.FormGroupDirective }, { type: i1.FormBuilder }, { type: i0.ChangeDetectorRef }, { type: i2.Store }, { type: i3.AppServicesLibraryService }]; }, { validation: [{
            type: Input
        }], readonly: [{
            type: Input
        }], sublabel: [{
            type: Input
        }], minLength: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], placeHolders: [{
            type: Input
        }], value: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class CustomTextFieldModule {
}
CustomTextFieldModule.ɵfac = function CustomTextFieldModule_Factory(t) { return new (t || CustomTextFieldModule)(); };
CustomTextFieldModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomTextFieldModule });
CustomTextFieldModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomTextFieldModule, { declarations: [CustomTextFieldComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule], exports: [CustomTextFieldComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomTextFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomTextFieldComponent],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule
                ],
                exports: [CustomTextFieldComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-text-field
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomTextFieldComponent, CustomTextFieldModule, CustomTextFieldService };
//# sourceMappingURL=custom-text-field.js.map
